import React from "react";
import { SvgIcon, SvgIconProps } from "@mui/material";
import supportTicketsTokens from "screens/Tickets/SupportTickets.tokens";

const { size, color } = supportTicketsTokens;

/**
 * Line glyphs traced from the Support Tickets design. `@mui/icons-material`
 * ships filled icons at a heavier optical weight, so these are drawn here with
 * the stroke width and sizing coming from the screen tokens.
 */
const StrokeIcon: React.FC<SvgIconProps> = ({ children, sx, ...rest }) => (
  <SvgIcon
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
    sx={{
      // SvgIcon sets `fill: currentColor`, which would beat the `fill="none"`
      // attribute and flood the outline glyph.
      fill: "none",
      ...sx,
    }}
    {...rest}
  >
    {children}
  </SvgIcon>
);

/** Flag in the round well of the "No open tickets" placeholder. */
export const NoTicketsIcon: React.FC<SvgIconProps> = (props) => (
  <StrokeIcon
    strokeWidth={size.emptyIconStrokeWidth}
    htmlColor={color.subtle}
    {...props}
  >
    <path d="M4 15s1-1 4-1 5 2 8 2 4-1 4-1V3s-1 1-4 1-5-2-8-2-4 1-4 1z" />
    <path d="M4 22v-7" />
  </StrokeIcon>
);

const PagerChevron: React.FC<SvgIconProps> = ({ sx, ...rest }) => (
  <StrokeIcon
    strokeWidth={size.pageArrowStrokeWidth}
    sx={{ width: size.pageArrow, height: size.pageArrow, ...sx }}
    {...rest}
  />
);

/** Chevron closing the Category / Priority selects in the create dialog. */
export const ChevronDownIcon: React.FC<SvgIconProps> = (props) => (
  <StrokeIcon strokeWidth={2} {...props}>
    <path d="M6 9l6 6 6-6" />
  </StrokeIcon>
);

export const PagerPrevIcon: React.FC<SvgIconProps> = (props) => (
  <PagerChevron {...props}>
    <path d="M15 18l-6-6 6-6" />
  </PagerChevron>
);

export const PagerNextIcon: React.FC<SvgIconProps> = (props) => (
  <PagerChevron {...props}>
    <path d="M9 6l6 6-6 6" />
  </PagerChevron>
);
